import { useState } from 'react'
import { AlertTriangle, ChevronDown } from 'lucide-react'
import styles from './IssueFlag.module.css'

export interface IssueFlagProps {
  code: string
  title: string
  description: string
  defaultOpen?: boolean
}

export function IssueFlag({ code, title, description, defaultOpen = false }: IssueFlagProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className={styles.flag}>
      <button className={styles.header} onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <AlertTriangle size={15} className={styles.alertIcon} />
        <span className={styles.code}>{code}</span>
        <span className={styles.title}>{title}</span>
        <ChevronDown size={15} className={[styles.chevron, open ? styles.chevronOpen : ''].join(' ')} />
      </button>
      {open && (
        <div className={styles.body}>
          <p className={styles.description}>{description}</p>
        </div>
      )}
    </div>
  )
}
